import { configuration } from '../constants/configuration';

interface IConfig {
  stripeKey: string,
}

export const readConfig = (): IConfig => ({ stripeKey: configuration[process.env.NODE_ENV === 'production' ? 'stripeKeyLive' : 'stripeKey'] });
